import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ConversationalPowerMoves } from "@/components/power-moves/ConversationalPowerMoves";
import { CareerArtifactIntelligence } from "@/components/career-tools/CareerArtifactIntelligence";

const PowerMovesPage = () => {
  const navigate = useNavigate();
  const [completedArtifacts] = useState(['assessment', 'big-sheet']);
  const [userScore] = useState(68);
  
  return (
    <div className="min-h-screen bg-background py-4 sm:py-6 md:py-8 overflow-x-hidden">
      <div className="container max-w-7xl mx-auto px-3 sm:px-4">
        <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/artifacts")}
            className="hover:bg-accent touch-target-min"
          >
            <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5" />
            <span className="ml-2 hidden sm:inline">Back</span>
          </Button>
          <div className="min-w-0 flex-1">
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Power Moves™
            </h1>
            <p className="text-text-secondary mt-1 text-xs sm:text-sm md:text-base">Strategic career action planning across time horizons</p>
          </div>
        </div>

        <div className="mb-6 sm:mb-8">
          <CareerArtifactIntelligence 
            userScore={userScore}
            completedArtifacts={completedArtifacts}
            recentActivity={['power-moves']}
          />
        </div>

        <ConversationalPowerMoves />
      </div>
    </div>
  );
};

export default PowerMovesPage;